import { DateTime } from 'luxon'

import type { Options } from '@/components/UI/Form/types'

type GenerateSessionPrepSessionOptionsParams = {
  id: number
  sessionTitle: string | null
  topicName: string
  seriesTitle: string | null
  startDateTime: DateTime
}[]

// When a user is submitting "Session Prep" volunteer hours, they must select
// the associated session.
export default function generateSessionPrepSessionOptions(
  sessions: GenerateSessionPrepSessionOptionsParams
): Options {
  return sessions.map(({ id, sessionTitle, topicName, seriesTitle, startDateTime }) => {
    const sessionTitleToUse = sessionTitle ?? topicName

    const sessionDate = startDateTime.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)

    return {
      label: `${
        seriesTitle != null ? `"${seriesTitle}" Series | ` : ''
      }${sessionTitleToUse} (${sessionDate})`,
      value: `${id}`,
    }
  })
}
